
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import FormGroup from "@/components/form/FormGroupNew.vue";
import FormInputGroup from "@/components/form/FormInputGroupNew.vue";
import FormDatepicker from "@/components/form/FormDatepickerNew.vue";
import FormTextarea from "@/components/form/FormTextarea.vue";
import _ from "lodash";
import moment from "moment";

@Component({
  components: {
    FormGroup,
    FormInputGroup,
    FormTextarea,
    FormDatepicker,
  },
})
export default class HomeEnvironment extends Vue {
  @Prop({ required: true }) readonly formData!: Record<string, any>;
  localFormData: Record<string, any> = {};

  @Watch("formData", { immediate: true, deep: true })
  onFormDataChange(newVal: Record<string, any>) {
    this.localFormData = _.cloneDeep(newVal);
  }

  updateField(field: string, value: any, isDate: boolean = false) {
    if (isDate) {
      this.localFormData[field] = moment(value).toISOString();
    } else {
      this.localFormData[field] = value;
    }
    this.$emit("update:formData", this.localFormData);
  }
}
